import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { INzMessageType } from '@ascschool/interface/setting';
import { ForgotPasswordService } from '@ascschool/services/user/forgot-password.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-xac-nhan-otp',
    templateUrl: './xac-nhan-otp.component.html',
    styleUrls: ['./xac-nhan-otp.component.scss']
})
export class XacNhanOTPComponent implements OnInit {
    href: string = "";
    isToken: boolean = false;
    validateForm!: FormGroup;
    validateFormChange = new FormGroup({
        password: new FormControl('',Validators.required),
        confirmPassword: new FormControl('',Validators.required),
        token: new FormControl('',Validators.required),
    });
    constructor(private fb: FormBuilder,
        private service: ForgotPasswordService,
        private utils: UtilsService,
        private router: Router
    ) { }

    ngOnInit() {
        this.href = this.router.url.split("token=")[1];
        this.validateForm = this.fb.group({
            otpCode: '',
            token: ''
        });
        // this.validateFormChange = this.fb.group({
        //     password: [''],
        //     confirmPassword: [''],
        //     token: [''],
        // });
        this.validateFormChange.get('token').setValue(this.href);
    }

    SubmitOTP(){
        this.validateForm.get('token').setValue(this.href);
        this.service.checkOTPCode(this.validateForm.value).subscribe(response=>{
            if(response.statusCode === 0){
                this.isToken = true;
                this.utils.showNotification(INzMessageType.Success,'Nhập mã OTP thành công', 5000);
            }else{
                this.isToken = false;
                this.utils.showNotification(INzMessageType.Error,response.message, 5000);
            }
        });
    }

    Submit() {
        if(this.validateFormChange.valid){
            this.validateFormChange.get('password').setValue(this.utils.md5Encode(this.validateFormChange.get('password').value));
            this.validateFormChange.get('confirmPassword').setValue(this.utils.md5Encode(this.validateFormChange.get('confirmPassword').value));
            this.service.changePasswordByToken(this.validateFormChange.value).subscribe(data => {
                if (data.statusCode === 0) {
                    this.utils.showNotification(INzMessageType.Success, "Xác thực thành công", 5000);
                    this.router.navigateByUrl(`/dangnhap`);
                } else {
                    this.utils.showNotification(INzMessageType.Error, data.message, 5000);
                }

            }, error=>{
                this.utils.showNotification(INzMessageType.Error, error.error.errors.ConfirmPassword[0], 5000);
            })
        }else{
            this.utils.showNotification(INzMessageType.Error, "Vui lòng nhập trường bắt buộc", 5000);
        }
    }
}
